import { IoChevronBack, IoVideocamOutline, IoTimeOutline, IoCheckmarkCircle } from "react-icons/io5";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Analytics } from '../compornents/Analytics';
import { Post } from '../compornents/Post';
import { TailSpin } from 'react-loading-icons';

export const CustomerService = () => {
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);       // { in_hours, hours_start, hours_end, meet_url }
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [topic, setTopic] = useState('');
  const [done, setDone] = useState(null);       // 受付完了の表示 { kind, meet_url }

  // 戻る（直リンク流入でも安全にアカウントへ）
  const back = () => navigate("/account");

  useEffect(() => {
    let mounted = true;
    (async () => {
      const res = await Post('post', '/customer/cs_info.php', {});
      if (mounted) {
        if (res?.result === 1) setInfo(res);
        setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  // 通話開始 / 折り返し依頼
  const startCall = async () => {
    if (sending) return;
    setSending(true);
    const res = await Post('post', '/customer/cs_call.php', { topic });
    setSending(false);
    if (res?.result !== 1) {
      alert(res?.error_message || '受付に失敗しました。時間をおいて再度お試しください。');
      return;
    }
    setDone({ kind: res.kind, meet_url: res.meet_url });
    // 受付時間内なら通話URLを自動で開く（ブロックされても下にリンクを出す）
    if (res.kind === 'now' && res.meet_url) {
      window.open(res.meet_url, '_blank');
    }
  };

  return (
    <div className="App">
      <div className="CustomerService">
        <Analytics title="カスタマーサービス" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back} >
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            カスタマーサービス
          </div>
          <div className="toolbar_right">
          </div>
        </div>

        <div className="content" style={{ padding: '0 1.25rem' }}>
          {loading && (
            <div className="text-center mt-5"><TailSpin stroke="#000" /></div>
          )}

          {!loading && (
            <>
              {/* 案内 */}
              <div className="text-center mt-3 mb-3">
                <IoVideocamOutline style={{ fontSize: 44, color: '#ffce00' }} />
                <div className="h5 mt-2">ビデオ通話でご相談</div>
                <div className="text-gray-dark" style={{ fontSize: 13 }}>
                  仕上がり・配送・ご注文などについて、運営スタッフとビデオ通話でご相談いただけます。
                </div>
              </div>

              {/* 休止中 */}
              {info && info.suspended && (
                <div className="rounded p-3 mb-3" style={{ background: '#fdecec', color: '#a33' }}>
                  <div style={{ fontWeight: 600 }}>ただいまビデオ相談を休止しております</div>
                  <div style={{ fontSize: 13, marginTop: 4 }}>
                    ご不便をおかけします。お問い合わせは「お問い合わせフォーム」をご利用ください。
                  </div>
                </div>
              )}

              {/* 受付時間 */}
              {info && !info.suspended && (info.hours_start && info.hours_end) && (
                <div
                  className="rounded p-3 mb-3"
                  style={{ background: info.in_hours ? '#e8f7ee' : '#f6f6f6', display: 'flex', alignItems: 'center', gap: 10 }}
                >
                  <IoTimeOutline style={{ fontSize: 22, color: info.in_hours ? '#1a9e54' : '#999', flex: '0 0 auto' }} />
                  <div style={{ fontSize: 13 }}>
                    <div style={{ fontWeight: 600 }}>
                      受付時間 {info.hours_start}〜{info.hours_end}
                      <span style={{ marginLeft: 8, color: info.in_hours ? '#1a9e54' : '#c0392b' }}>
                        {info.in_hours ? '● ただいま受付中' : '● 時間外'}
                      </span>
                    </div>
                    {!info.in_hours && (
                      <div className="text-gray-dark" style={{ marginTop: 2 }}>
                        時間外のため、折り返しのご連絡を承ります。
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* 受付完了表示 */}
              {done ? (
                <div className="rounded p-4 text-center" style={{ background: '#fffbe6' }}>
                  <IoCheckmarkCircle style={{ fontSize: 40, color: '#1a9e54' }} />
                  {done.kind === 'now' ? (
                    <>
                      <div className="h6 mt-2">受付しました</div>
                      <div className="text-gray-dark" style={{ fontSize: 13 }}>
                        ビデオ通話の画面を開きます。開かない場合は下のボタンを押してください。
                      </div>
                      {done.meet_url && (
                        <a href={done.meet_url} target="_blank" rel="noreferrer"
                          className="btn btn-oval btn-yellow form-control mt-3">
                          通話画面を開く
                        </a>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="h6 mt-2">折り返しのご依頼を受け付けました</div>
                      <div className="text-gray-dark" style={{ fontSize: 13 }}>
                        受付時間内に担当よりご連絡いたします。<br />しばらくお待ちください。
                      </div>
                    </>
                  )}
                  <button className="btn btn-oval btn-outline-secondary form-control mt-3" onClick={back}>
                    アカウントに戻る
                  </button>
                </div>
              ) : info?.suspended ? (
                <button className="btn btn-oval btn-outline-secondary form-control mt-3" onClick={back}>
                  アカウントに戻る
                </button>
              ) : (
                <>
                  {/* ご相談内容（任意） */}
                  <div className="mb-2" style={{ fontSize: 13, fontWeight: 600 }}>ご相談内容（任意）</div>
                  <textarea
                    className="form-control mb-3"
                    rows={3}
                    placeholder="例）注文番号や、ご相談されたい内容を入力いただくとスムーズです"
                    value={topic}
                    onChange={(e) => setTopic(e.target.value)}
                    style={{ resize: 'none' }}
                  />

                  {/* 開始ボタン */}
                  <button
                    className={`btn btn-oval form-control ${info?.in_hours ? 'btn-yellow' : 'btn-outline-secondary'}`}
                    onClick={startCall}
                    disabled={sending}
                  >
                    {sending ? '受付中…' : (info?.in_hours ? 'ビデオ通話を始める' : '折り返しを依頼する')}
                  </button>

                  <div className="text-gray-dark text-center mt-2" style={{ fontSize: 12 }}>
                    {info?.in_hours
                      ? 'ボタンを押すと通話画面が開き、担当へ着信をお知らせします。'
                      : 'お名前・お電話番号をもとに担当よりご連絡します。'}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
